import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { store } from './store';
import interceptor from './services/interceptors';

// Condominium
import condominium from './utility/condominium';
import Spinner from './components/spinner';

import './assecs/scss/style.scss'

// Pages
const Index = lazy(() => import('./pages/index'));
const Login = lazy(() => import('./pages/login'));
const Reset = lazy(() => import('./pages/reset'));

// Components
const Alerts = lazy(() => import('./components/alerts'));

const App = () => {
	const type = useSelector(state => state.model.type);
	const { _switch } = useSelector(state => state.spinner);
	
	return (
		<BrowserRouter>
			<Suspense fallback={ <Spinner /> }>
				<Routes>
					<Route exact path="/login" name="Login page" element={<Login />} />
					<Route exact path="/reset" name="Reset passwore page" element={<Reset />} />
					<Route path="*" element={ <Index /> } />
				</Routes>
				{ _switch && <Spinner /> }
				{ condominium[type] }
				<Alerts />
			</Suspense>
		</BrowserRouter>
	)
};

interceptor(store);
  
export default App;
